import React from 'react';
import styles from "./aboutSection.module.sass"
import line from "../../assets/Line 16.png"
import small_line from "../../assets/small_line_about.png"
import woman_with_dog from "../../assets/woman_with_dog.png"
import woman_back from "../../assets/woman_back.png"
import man_with_cardigan from "../../assets/man_grey_cardigan.png"
import man_blue_jacket from "../../assets/man_blue_jacket.png"
import man_blue from "../../assets/about_man_blue.png"
import man_grey from "../../assets/about_man_grey.png"
import woman_white from "../../assets/about_woman_white.png"
import woman from "../../assets/image 72.png"

export const AboutSection = () => {
    return (
        <div className={styles.section__wrap__about} id='sectionAbout'>
            <span className={styles.section__text__about}>Кто мы такие?</span>
            <div className={styles.section__line__imgWrap}>
                <img className={styles.section__line__img} src={line} alt=""/>
            </div>
            <div>
                <div className={styles.column__elem__1}>
                    <div className={styles.column__inner__1}>
                        <img src={woman_with_dog} alt=""/>
                        <div className={styles.innerColumn__text__block1}>
                        <span className={styles.column__header__textColumn1}>
                            Сеть салонов одежды больших размеров «Ваше
Величие» уже долгие годы является одним из лидеров в сфере продаж одежды больших размеров.
                        </span>
                            <img className={styles.column__small__line} src={small_line} alt=""/>
                            <span className={styles.column__default__textColumn1}>
                        Огромный ассортимент - от нижнего белья до курток и дублёнок, включая классическую одежду и костюмы.
Лояльные цены и система скидок.
                        </span>
                        </div>
                        <img src={woman_back} alt=""/>
                    </div>
                    <div className={styles.column__inner__2}>
                        <div className={styles.innerColumn__text__block2}>
                        <span className={styles.column__header__textColumn2}>
                        Более 20 лет на рынке больших размеров. Более 15 тысяч постоянных клиентов.
                        </span>
                            <div className={styles.column__small__lineWrap}>
                                <img className={styles.column__small__line} src={small_line} alt=""/>
                            </div>
                            <span className={styles.column__default__textColumn2}>
                        Наша цель - дарить людям больших размеров возможность и радость красиво, комфортно и доступно одеваться.
                        </span>
                        </div>
                        <img src={man_with_cardigan} alt=""/>
                        <div className={styles.innerColumn__text__block3}>
                        <span className={styles.column__header__textColumn2}>
                        Размеры от 52-го до 82-го.
И все это «Ваше Величие»!
                        </span>
                            <div className={styles.column__small__lineWrap}>
                                <img className={styles.column__small__line} src={small_line} alt=""/>
                            </div>
                            <span className={styles.column__default__textColumn2}>
                        Не надо мучиться, искать, когда у нас всё можно взять.
Огромный выбор моделей из Турции и России, доставка по всей России
                        </span>
                        </div>
                        <img src={man_blue_jacket} alt=""/>
                    </div>
                </div>
                <div className={styles.column__elem__2}>
                    <img className={styles.man__blue} src={man_blue} alt=""/>
                    <img className={styles.woman__white__img} src={woman_white} alt=""/>
                    <img className={styles.man__grey} src={man_grey} alt=""/>
                </div>
                <div className={styles.column__elem__3}>
                    <img className={styles.woman} src={woman} alt=""/>
                </div>
            </div>
        </div>
    );
};
